export default __webpack_public_path__ + "static/media/ico badge 2.2335c0b0.svg";